import React from 'react'
import Table from 'react-bootstrap/Table';
import ManageSubsByClient from 'alert_subscriptions/ManageSubsByClient';

class SubsByClient extends React.Component {
  constructor(props) {
    super(props);
  }

  searchClients(event) {
    let filter = event.target.value;
    let clients = document.getElementsByClassName("client-row-by-client");
    this.props.searchClients(filter, clients);
  }

  render() {
    return (
      <>
        <h3>Subscriptions By Client</h3>
        <div className="off-color-bg subs-by-client table-responsive">
          <Table striped className="table-white">
            <thead>
              <tr>
                <th className="text-center search-color head-1" rowSpan="2">
                  Client Name
                  <div className="client-search">
                    <span className="fa fa-search"></span>
                    <input onChange={(e) => this.searchClients(e)} />
                  </div>
                </th>
                <th colSpan="4" className="text-center ppc-color head-1">PPC</th>
                <th className="text-center seo-color head-1" rowSpan="2">SEO</th>
              </tr>
              <tr>
                <th className="text-center ppc-color head-2">Search</th>
                <th className="text-center ppc-color head-2">Social</th>
                <th className="text-center ppc-color head-2">Display</th>
                <th className="text-center ppc-color head-2">Video</th>
              </tr>
            </thead>
            <tbody>
            {
              this.props.clients.map((client) => {
                console.log(client)
                return (
                  <tr key={client.id} className="client-row-by-client" data-client-name={client.company_name}>
                    <th className="company-name"><h4 style={{ fontSize: "20px", marginTop: "8px" }}>{client.company_name}</h4></th>
                    <td>
                      <ManageSubsByClient
                        users={this.props.users}
                        addUser={this.props.addUser}
                        removeUser={this.props.removeUser}
                        subscribed_users={client.search_subs}
                        section_id={client.search_section_id}
                        searchUsers={this.props.searchUsers}
                        section_name="SearchSection"
                        client_name={client.company_name} />
                    </td>
                    <td>
                      <ManageSubsByClient
                        users={this.props.users}
                        addUser={this.props.addUser}
                        removeUser={this.props.removeUser}
                        subscribed_users={client.social_subs}
                        section_id={client.social_section_id}
                        searchUsers={this.props.searchUsers}
                        section_name="SocialSection"
                        client_name={client.company_name} />
                    </td>
                    <td>
                      <ManageSubsByClient
                        users={this.props.users}
                        addUser={this.props.addUser}
                        removeUser={this.props.removeUser}
                        subscribed_users={client.display_subs}
                        section_id={client.display_section_id}
                        searchUsers={this.props.searchUsers}
                        section_name="DisplaySection"
                        client_name={client.company_name} />
                    </td>
                    <td>
                      <ManageSubsByClient
                        users={this.props.users}
                        addUser={this.props.addUser}
                        removeUser={this.props.removeUser}
                        subscribed_users={client.video_subs}
                        section_id={client.video_section_id}
                        searchUsers={this.props.searchUsers}
                        section_name="VideoSection"
                        client_name={client.company_name} />
                    </td>
                    <td>
                      <ManageSubsByClient
                        users={this.props.users}
                        addUser={this.props.addUser}
                        removeUser={this.props.removeUser}
                        subscribed_users={client.seo_subs}
                        section_id={client.seo_section_id}
                        searchUsers={this.props.searchUsers}
                        section_name="SeoSection"
                        client_name={client.company_name} />
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </Table>
        </div>
      </>
    )
  }
}

export default SubsByClient;
